<template>
  <!-- <div class="box box-info"> -->
  <form>
    <website ref="website"/>
    <!-- <div class="name"> -->

    <div class="page section-header text-center">
      <h1>{{ displayItemList[0].groupName }}</h1>
    </div>
    <div class="page-width">
      <div class="grid">
        <div class="row p-mt-3">
          <div class="col-md-2">
            <h6>FILTER BY SIZE</h6>
            <div class="p-field-checkbox">
              <Checkbox name="city" value="Chicago" v-model="cities"/>
              <label >3-4 Yrs</label>
            </div>

            <div class="p-field-checkbox">
              <Checkbox  name="city" value="Los Angeles" v-model="cities"/>
              <label >4-5 Yrs</label>
            </div>

            <div class="p-field-checkbox">
              <Checkbox name="city" value="New York" v-model="cities"/>
              <label >5-6 Yrs</label>
            </div>

            <div class="p-field-checkbox">
              <Checkbox  name="city" value="San Francisco" v-model="cities"/>
              <label >7-8 Yrs</label>
            </div>
            <div class="p-field-checkbox">
              <Checkbox  name="city" value="San Francisco" v-model="cities"/>
              <label >8-10 Yrs</label>
            </div>
            <div class="p-field-checkbox">
              <Checkbox name="city" value="San Francisco" v-model="cities"/>
              <label >10-12 Yrs</label>
            </div>
            <div class="p-field-checkbox">
              <Checkbox  name="city" value="San Francisco" v-model="cities"/>
              <label >12-14 Yrs</label>
            </div>
          </div>
          <div class="col-md-10">
            <div class="filters-toolbar__item filters-toolbar__item--count">
        	<span class="filters-toolbar__product-count">
              	
              		Showing: {{displayItemList.length}}
              	
          	</span>
      	</div>
            <DataView :value="displayItemList" :paginator="false" :lazy="true" style="width: 100%;" :rows="200"
                      :layout="layout">
              <template #header>
                <div class="p-grid p-nogutter" style="margin: 0% 0% 0% 90%;">
                  <div class="p-col-6" style="text-align: left">
                    <Dropdown v-model="sortKey" :options="sortOptions" optionLabel="label" placeholder="Sort"
                              @change="onSortChange($event)"/>
                  </div>
                  <div style="margin: 0% -942%;" class="p-col-6">
                    <DataViewLayoutOptions class="filters-toolbar__item collection-view-as"/>
                  </div>
                </div>
              </template>
              <template #grid="slotProps">
                <div class="p-col-12 p-md-3" style="border-bottom: 0px solid #c8c8c8;">
                  <div class="productList">
                    <div class="grid__item small--one-half medium--one-third large-up--one-quarter">
                      <div class="grid-view-item style1 wow fadeIn">
                        <div class="grid-view_image">
                          <a href="">
                            <img @click="viewProductDetailsPage(slotProps.data)" :src="slotProps.data.singleImageUrl"
                                 :alt="slotProps.data.name" style="height: 300px;width: 85%;"/></a>
                         
                        </div>
                         <div class="grid-view-item__title">{{ slotProps.data.name }}</div>
                          <span class="product-price__price">Nrs.{{ slotProps.data.salesRate }}</span>
                          <div class="product-description">{{ slotProps.data.description }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template #list="slotProps">
                <div class="p-col-12 p-md-1" style="border-bottom: 0px solid #c8c8c8;">
                  <div class="product-list-item">
                    <div class="list__item small--one-half medium--one-third large-up--one-quarter">
                      <div class="list-view-item style1 wow fadeIn">
                        <div class="product-list-detail">
                          <a href="">
                            <img @click="viewProductDetailsPage(slotProps.data)" :src="slotProps.data.singleImageUrl"
                                 :alt="slotProps.data.name" style="height: 300px;width: 85%;"/></a>
                          <div class="list-view-item__title">{{ slotProps.data.name }}</div>
                          <span class="product-price__price">Nrs.{{ slotProps.data.salesRate }}</span>
                          <div class="product-description">{{ slotProps.data.description }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              
            </DataView>
          </div>
        </div>
      </div>
    </div>


    <!-- </div> -->
    <footerWebsite ref="footerWebsite"/>
  </form>

  <!-- </div> -->
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions'
import Checkbox from 'primevue/checkbox'
import DatePicker from 'vue2-datepicker'
import Carousel from 'primevue/carousel'
import DataView from 'primevue/dataview'
import Galleria from 'primevue/galleria'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import TextArea from 'primevue/textarea'
import website from './website.vue'
import footerWebsite from './footerWebsite.vue'

export default {
  name: 'collections',
  props: ['collections'],
  data() {
    return {
      name: '',
      layout: 'grid',
      id: '',
      type: '',
      sortOrder: null,
      sortKey: '',
      cities: [],
      searchTerm: '',
      sortField: null,
      displayItemList: [],
      sortOptions: [
        {label: 'Featured', value: 'Featured'},
        {label: 'Best Selling', value: 'Best Selling'},
        {label: 'Alphabetically, A-Z', value: 'Alphabetically, A-Z'},
        {label: 'Alphabetically, Z-A', value: 'Alphabetically, Z-A'},
        {label: 'Price, low to high', value: 'Price, low to high'},
        {label: 'Price, high to low', value: 'Price, high to low'},
        {label: 'Date, new to old', value: 'Price, new to old'},
        {label: 'Date, old to new', value: 'Price, old to new'}
      ]
    }
  },
  created() {
    this.itemsList()
  },
  computed: {},
  mounted() {
  },
  methods: {
    async itemsList() {
      if (this.collections === undefined) {
        this.id = this.$route.query.item
        this.type = this.$route.query.typ
        if (this.type === 'group') {
          let response = await this.$store.dispatch('loadItemMasterListByGroupIdForSite', this.id)
          this.displayItemList = response.data.data
        } else {
          let response = await this.$store.dispatch('loadItemMasterListBySubGroupIdForSite', this.id)
          this.displayItemList = response.data.data
        }
        // this.productObject = response.data.data
      }
    },
    searchItemWithUserInput() {
      // // debugger
      let filteredItemList = this.displayItemList.filter(item => {
        return item.name.toLowerCase().includes(this.searchTerm.toLowerCase())
      })
      this.displayItemList = filteredItemList
      if (filteredItemList.length !== 0) {
        this.salesItem = filteredItemList[0]
      }
      if (this.searchTerm === '') {
        this.itemsList()
      }
    },
    async viewProductDetailsPage(data) {
      let PIHdata = {
        id: data.id,
        itemName: data.name,
        imgUrl: data.singleImageUrl,
        sellingPrice: data.salesRate,
        description: data.description,
        itemCode: data.itemCode,
        groupName: data.groupName,
        images: data.imageList
      }
      this.$router.push({name: 'Product Detail', params: {productObject: PIHdata}, query: {item: PIHdata.id}})
    }
  },
  components: {
    Dropdown,
    DataViewLayoutOptions,
    DatePicker,
    Checkbox,
    AutoComplete,
    InputNumber,
    InputMask,
    Button,
    InputText,
    TextArea,
    Carousel,
    Galleria,
    DataView,
    website,
    footerWebsite
  }
}
</script>
<style scoped src="@../../../static/css/website.css">
.p-dataview .p-dataview-header {
  background: #f8f9fa;
  color: #495057;
  border: 0px solid #ffffff;
  border-width: 0px 0 10px 0;
  padding: 1rem 1rem;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// collections.vue?4750d64c